
import Edit from './edit.js';

const { registerBlockType,
        registerBlockStyle }   =   wp.blocks;
const { InnerBlocks,
        RichText }             =   wp.blockEditor;

registerBlockType('diviner-blocks/info', {
    title: 'Info Box',
    description: 'Hightlight important information using Info Block',
    category: 'diviner-blocks',
    icon: {
        src: 'info',
        foreground: '#1d7eb6'
    },

    attributes: {
        bgImage: {
            type: 'object',
            default: {}
        },
        textTitle: {
            type: 'string',
            default: '',
        },
        textContent: {
            type: 'string',
            default: '',
        },
         align: {
	        type: 'string',
	        default: 'center'
        }
    },
    
     supports: {
	    align: ['wide', 'full']
    },

    styles: [
        {
            name: 'default',
            label: 'Info Box - Default',
            isDefault: true
        },
        {
            name: 'toggled',
            label: 'Info Box - Toggled'
        }
    ],

    edit: Edit,

    save: (props) => {

        const { attributes } = props;

        return(
        <div className="db-info-container">
            <div className="column_1">
                <div class="db-media" style={ {
                    backgroundImage: `url(${attributes.bgImage.url})`
                    } }></div>
            </div>
            <div class="column_2"
                 style={ { background: attributes.textBg } }>
            <RichText.Content
                    className="db-title title-font"
                    style={ { color: attributes.textColor } }
                    tagName="h2"
                    value={ attributes.textTitle }
                    />
            <RichText.Content
                    className="db-content"
                    style={ { color: attributes.textColor } }
                    tagName="p"
                    value={ attributes.textContent }
                  />
            </div>
        </div>
        )
    }
});
alert('456');
